import type { TProperty } from 'stores/fieldAssetStore/helperTypes'
import { sortByKey } from 'utils/sortByKey'

export const mapPropertiesForPropertySelect = (properties: TProperty[]) =>
  properties.map((p) => ({ value: p.propertyId.toString(), label: p.propertyName })).sort(sortByKey('label'))
